import { render, staticRenderFns } from "./ProductButton.vue?vue&type=template&id=7a230a19&"
import script from "./ProductButton.vue?vue&type=script&lang=js&"
export * from "./ProductButton.vue?vue&type=script&lang=js&"
import style0 from "./ProductButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports